import { Box, Grid, Stack, Typography, Button } from "@mui/material";
import PageLayout from "../../components/PageLayout";
import logo from "../../assets/images/defaults/logo-dark.png"
import { ChevronRight } from '@mui/icons-material';
import logout from "../../assets/images/logout.svg";
import { useDispatch } from "react-redux";
import { appConfigs, oktaConfigs } from "../../constants/ApplicationConstants";
import { useOktaAuth } from "@okta/okta-react";

export default function UnAuthorisedScreen(){
    const dispatch= useDispatch();
    const { oktaAuth }= useOktaAuth();
    async function handleLogout(){
        dispatch({type: 'LOGOUT'});
        await oktaAuth.signOut({ postLogoutRedirectUri: window.location.origin + oktaConfigs.oktaLogoutURL });
    };


    return(
        <PageLayout header={false} footer={false}>
            <Box>
                <Grid container spacing={2} sx={{ flexGrow: 1 }}>
                    <Grid item xs={4}>
                        <Box marginLeft={10}>
                            <Stack direction="column" justifyContent="space-between" alignItems="flex-start" spacing={12}>
                                <img alt="explore" src={logo} style={{
                                    width: '75%', height: '75%'
                                }} />
                                <Typography variant="h2">You are not authorised to view this page.</Typography>
                                <Button sx={{ textTransform: 'capitalize' }} onClick={()=>handleLogout()} variant="contained" color="primary">Logout<ChevronRight style={{marginLeft: '1rem'}} /></Button>
                                <Typography color="gray" fontSize={'0.5rem'}>{appConfigs.footerText}</Typography>
                            </Stack>
                        </Box>
                    </Grid>
                    <Grid item xs={8}>
                        <img alt="explore" src={logout} style={{
                            width: '90%', height: '90%'
                        }} />
                    </Grid>
                </Grid>
            </Box>
        </PageLayout>
    )
}